import React from 'react';
import { IconBarWrapper } from './_styles/iconBarWrapper';

function Bar(props) {
    // // console.log("PROPS: ", props);
    return (
        <>
            <IconBarWrapper complete={props.complete} current={props.current}>
                <div className="progressFill">
                    <div className="progressContent">
                        {
                            props.complete
                            ? <div>&#10004;</div>
                            : <div className={"progressIcon"}>
                                <img src={props.data.icon} alt="icon" />
                            </div> 
                        }
                    </div>
                </div>
                <div className="progressTitle">{props.data.title}</div>
            </IconBarWrapper>
        </>
    );
}

export default Bar;